module.exports = __webpack_public_path__ + "img/limit_7- 9.699d84b2.png";